import * as React from 'react';
var Partner = function (_a) {
    var element = _a.element;
    return (React.createElement("div", { className: "partner-img" },
        React.createElement("a", { href: element.url, target: "_blank" },
            React.createElement("img", { src: element.logo, alt: element.name, className: 'card__image' }))));
};
export default Partner;
